import React from 'react';
import whatsappIcon from '../../../assets/icons/whatsapp.svg';
import './styles.sass';

const WHATSAPP_NUMBER = '5519981520335';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;
const WHATSAPP_LABEL = 'Fale conosco pelo WhatsApp';

export const WhatsAppButton: React.FC = () => {
  return (
    <a
      className="whatsapp-floating-button"
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      title={WHATSAPP_LABEL}
      aria-label={WHATSAPP_LABEL}
    >
      <img src={whatsappIcon} alt="" aria-hidden="true" />
      <span className="whatsapp-floating-button__tooltip">{WHATSAPP_LABEL}</span>
    </a>
  );
};

export default WhatsAppButton;
